// extracted by mini-css-extract-plugin
export default {"container":"InviteFriends--container--W9+05","button":"InviteFriends--button--6-0Iv"};